

import View from "./view.js";


class AddRecipe extends View {
    _parentEl = document.querySelector('.upload');
    _modal    = document.querySelector(".add-recipe-window");
    _overlay  = document.querySelector(".overlay");
    _btnOpen  = document.querySelector(".nav__btn--add-recipe");
    _btnClose = document.querySelector(".btn--close-modal");
    _successMessage = "New recipe added successfully!";


    constructor() {
        super();
        this.addHandlerOpenModal();
        this.addHandlerCloseModal();
    }


    toggleModal() {
        this._overlay.classList.toggle("hidden");
        this._modal.classList.toggle("hidden");
    }


    addHandlerOpenModal() {
        this._btnOpen.addEventListener("click", this.toggleModal.bind(this));
    }


    addHandlerCloseModal() {
        this._btnClose.addEventListener("click", this.toggleModal.bind(this));
        this._overlay.addEventListener("click", this.toggleModal.bind(this));
    }


    addHandlerUpload(handler) {
        this._parentEl.addEventListener("submit", function(event) {
            event.preventDefault();

            const rawData = [...new FormData(this)];
            const data = Object.fromEntries(rawData);

            handler(data);
        });
    }
}


export default new AddRecipe();